export default function minCharacterRule(maxCharacters, value) {
  return value && value.length >= maxCharacters;
}

export function maxCharacterRule(minCharacters, value) {
  return value && value.length < minCharacters;
}
